import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logoICIAR from '../../assets/img/ICIAR-LOGO.png'
import { useForm } from "../../hooks/useForm";
import { AuthContext } from "../context/AuthContext";

export const Login = () => {

  const navigate = useNavigate();

  const {username, formData, onInputChange} = useForm();

  const {login} = useContext(AuthContext);

  const onLogin = (e) => {
    e.preventDefault();

    // login(username, `${username}@gmail.com`, 1234);

    // navigate("/admin/home", { replace: true });
    
    // Mensaje que por el momento no se utiliza, pero se deja para futuras implementaciones
    const message = `
    Hola, lamento informarte que el sistema de autenticación sigue en mantenimiento.
    Por favor, contacta al administrador para más información.
    `;

    // Mostrar mensaje al usuario (puede ser un alert, modal, etc.)
    alert(message);
  }

  return (
    <div className="container">

      <div className="form-signin col-12 col-md-6 m-auto ">
        <form>
          <div className="d-flex justify-content-center ">
            <img
              className="mb-4 mt-5"
              src={logoICIAR}
              alt=""
              width="72"
              height="102"
            />
          </div>
          <h1 className="h3 mb-3 fw-normal"> Ingresa tus datos de usuario: </h1>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="floatingInput"
              placeholder="ITSP - Usuario"
              name="username"
              autoComplete="username"
              onChange={onInputChange}
            />
            <label htmlFor="floatingInput">Usuario</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Contraseña"
              name="password"
              onChange={onInputChange}
              autoComplete="current-password"
            />
            <label htmlFor="floatingPassword">Contraseña</label>
          </div>

          <div className="checkbox mb-3">
            <label>
              <input type="checkbox" value="remember-me" /> Recordar la contraseña
            </label>
          </div>

          <button className="btn btn-lg btn-primary w-50" type="button" onClick={onLogin}>
            Ingresar
          </button>
          
          <p className="mt-5 mb-3 text-muted">Ingresar al portal del Insituto </p>
        </form>
      </div>
    </div>
  );
};
